module.exports = __webpack_public_path__ + "img/trending_large.82f9b79e.png";